<app-header class="fixed inset-x-0 top-0 z-20"></app-header>
<router-outlet></router-outlet>
<button
  (click)="toggleColor()"
  class="fixed top-0 right-0 z-50 p-4 md:p-6 focus:ring-0 focus:outline-none"
>
  <span
    class="
      block
      h-2
      w-2
      transform
      -translate-y-1/4
      bg-black
      dark:bg-white
      rounded-full
      font-bold
    "
  >
    &shy;
  </span>
</button>
